export const PERFORMING_LOGIN = 'PERFORMING_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const PERFORMING_LOGOUT = 'PERFORMING_LOGOUT';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";


// WEBPACK FOOTER //
// ./src/redux/auth/AuthConstants.js